import React from 'react';
import { NavLink } from 'react-router-dom';
import type { User } from '@/types/auth';

interface NavigationProps {
  user: User;
  isMobile?: boolean;
  onNavigate?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({
  user,
  isMobile = false,
  onNavigate
}) => {
  const isAdmin = user?.roles?.some(r => ['admin', 'solas-admin'].includes(r)) ?? false;

  const navItems = [
    {
      label: 'Dashboard',
      path: '/dashboard',
      icon: 'dashboard'
    },
    {
      label: 'Analyse',
      path: '/analyse',
      icon: 'psychology'
    },
    {
      label: 'History',
      path: '/history',
      icon: 'history'
    },
    {
      label: 'Analytics',
      path: '/analytics',
      icon: 'analytics',
      // Only show if user has completed 10+ analyses
      hidden: false // TODO: check user.analysis_count >= 10
    },
    {
      label: 'Admin',
      path: '/admin/users',
      icon: 'admin_panel_settings',
      hidden: !isAdmin
    }
  ];

  const linkClasses = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
      isActive
        ? 'bg-primary-50 text-primary-600 font-medium'
        : 'text-gray-700 hover:bg-gray-100'
    }`;

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <nav className={isMobile ? 'flex flex-col gap-2' : 'flex items-center gap-4'}>
      {navItems
        .filter(item => !item.hidden)
        .map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={linkClasses}
            onClick={handleClick}
          >
            <span className="material-symbols-outlined text-xl">
              {item.icon}
            </span>
            <span className="text-sm">{item.label}</span>
          </NavLink>
        ))}
    </nav>
  );
};

